<template>
  <div>
    <van-nav-bar title="新人福利领取" left-arrow @click-left="onClickLeft" />
    <div class="wrp">
      <img
        src="@/assets/detail-img.jpg"
        style="width: 100%; margin-bottom: 20px"
        @click="onDetail"
      />
      <van-dialog v-model="qrcodeShow" :title="tips_text" show-cancel-button>
        <div class="title">
          <text>{{ tips_text }}1</text>
        </div>
        <div class="image">
          <img style="width: 85%" :src="qrcodeUrl" />
          <div class="tips">(长按识别二维码)</div>
        </div>
      </van-dialog>
    </div>
  </div>
</template>
<script>
import vip from "../model/vipApp.js";
import { getWoYeBuZhiDao1Api } from "../api/api";

export default {
  data() {
    return {
      qrcodeShow: false,
      tips_text: "",
      qrcodeUrl: "",
    };
  },
  mounted() {
    console.log("agentCode", localStorage.getItem("agentCode"));
    this.cardInfo();

    vip.onVipApp((res) => {
      console.log("resresres", res);
      //已购
      if (res.isVip == 2) {
        this.tips_text = "此为新人专享福利\n您可以联系老师领取其他备考资料";
      } else {
        this.tips_text = "联系老师，领取新人大礼包";
      }
    });
  },
  methods: {
    onDetail: function () {
      this.qrcodeShow = true;
    },
    onClickLeft: function () {
      this.$router.push("/");
    },
    //获取官方和合作商老师二维码信息
    cardInfo() {
      let data = {
        agentCode: localStorage.getItem("agentCode"),
        cardid: localStorage.getItem("cardID"),
      };
      getWoYeBuZhiDao1Api(data).then((res) => {
        if (res.data.code == 0) {
          if (res.data.data) {
            this.qrcodeUrl = "https:" + res.data.data.wxurl;
          }
        } else {
          this.$toast("暂无找到老师信息");
        }
      });
    },
  },
};
</script>
<style scoped>
.wrp {
  width: 100%;
  height: 100vh;
  overflow-y: auto;
}
.detail {
  /* width:750rpx; */
}
.tips {
  color: #999999;
  text-align: center;
}
.title {
  /* padding: 13px 0;
  text-align: center; */
}
.image {
  text-align: center;
  margin-bottom: 100px;
}
</style>